import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import { Field, reduxForm } from 'redux-form'

import { displayDollars } from '../../helpers/displayFormatHelper'
import LoaderButton from '../../components/loaderButton'
import { Loan, Tradeline } from './types.js'
import { ReduxFormProps } from '../../forms'

export interface Props {
  loan: Loan
}

export interface FormProps {
  adjustments: string[]
  adminNote: string
}

export class TradelineForm extends Component<ReduxFormProps<Props, FormProps>> {
  renderTradeline = (tradeline: Tradeline, index: number) => {
    if (!tradeline) return null

    const {
      balance,
      creditType,
      joint,
      lastPaymentDate,
      originationDate,
      owner,
      payment,
      subscriber,
    } = tradeline

    return (
      <Fragment key={`tradeline-${index}`}>
        <tr>
          <td colSpan={7}>
            <h5 className="section-header">
              {subscriber}
              <div className="span section-header-owner">{owner}</div>
            </h5>
          </td>
        </tr>
        <tr>
          <th>Open Date</th>
          <th>Last Payment Date</th>
          <th>Joint Account</th>
          <th>Type</th>
          <th>Balance</th>
          <th>Payment Amount</th>
          <th>Adjust Amount</th>
        </tr>
        <tr>
          <td>{originationDate}</td>
          <td>{lastPaymentDate}</td>
          <td>{joint ? 'Yes' : 'No'}</td>
          <td>{creditType}</td>
          <td>{displayDollars(balance)}</td>
          <td>{displayDollars(payment)}</td>
          <td>
            <Field
              type="text"
              component="input"
              name={`adjustments[${index}]`}
            />
          </td>
        </tr>
      </Fragment>
    )
  }

  render() {
    const { loan, handleSubmit, submitting } = this.props

    const { tradelines } = loan

    const tradelinesHTML = tradelines.map(this.renderTradeline)

    let disabled = loan.adminStatus === 'EXPIRED'

    return (
      <form className="form" name="tradelineForm" onSubmit={handleSubmit}>
        <div className="table-responsive">
          <table id="tradelineTable" className="table loan-table">
            <tbody>{tradelinesHTML}</tbody>
          </table>
        </div>
        <div className="loan-buttons">
          <Field
            type="text"
            component="input"
            className="admin-note"
            name="adminNote"
            placeholder="Admin Note"
          />
          <LoaderButton
            type="submit"
            disabled={disabled}
            className={classnames('button __form__button--submit', {
              'button--primary': !disabled,
              'button--disabled': disabled,
            })}
            isLoading={submitting}
          >
            Redecision
          </LoaderButton>
        </div>
      </form>
    )
  }
}

export default reduxForm<FormProps, Props>({
  form: 'tradelineForm',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(TradelineForm)
